import { render, staticRenderFns } from "./debtor-asset-form.vue?vue&type=template&id=2d89137f&scoped=true&"
import script from "./debtor-asset-form.vue?vue&type=script&lang=js&"
export * from "./debtor-asset-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d89137f",
  null
  
)

export default component.exports